import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { isPresent } from 'utils'

const fetchEditingChannel = createAxiosThunk(
  'channelAdd/fetchEditingChannel',
  (noArgs, { getState }) =>
    api.channel.getChannelDetail(getState().channel.channelAdd.bizChannelId)
)

fetchEditingChannel.reducers = builder => {
  builder.addCase(fetchEditingChannel.pending, state => {
    state.isLoading = true
  })

  builder.addCase(fetchEditingChannel.fulfilled, (state, { payload }) => {
    state.bizChannelType = payload.bizChannelType
    state.name = payload.name
    state.reviewStatus = payload.reviewStatus

    if (payload.siteUrl.individualSettingYn === 'Y') {
      state.isUrlIndividual = true
      if (payload.siteUrl.mobileSiteYn === 'Y') {
        state.mobileUrl = `${payload.siteUrl.mobileUrl.protocol.toLowerCase()}://${
          payload.siteUrl.mobileUrl.url
        }`
        state.isMobileUrlChecked = true
      }
      if (payload.siteUrl.pcSiteYn === 'Y') {
        state.pcUrl = `${payload.siteUrl.pcUrl.protocol.toLowerCase()}://${
          payload.siteUrl.pcUrl.url
        }`
        state.isPcUrlChecked = true
      }
    } else {
      state.isUrlIndividual = false
      state.unifiedUrl = `${payload.siteUrl.pcUrl.protocol.toLowerCase()}://${
        payload.siteUrl.pcUrl.url
      }`
      state.isUnifiedUrlChecked = true
    }

    if (isPresent(payload.accessAccount)) {
      state.hasAccessAccount = true
      state.accessAccountId = payload.accessAccount.id
      state.accessAccountPassword = payload.accessAccount.passwd
    } else {
      state.hasAccessAccount = false
    }

    state.oldCategoryFullPath = payload.bizChannelCategory.categoryFullPath
    state.oldKakaoTalkChannels = payload.talkChannelAccounts
    state.oldReviewDocuments = payload.reviewDocuments
    state.isLoading = false
  })

  builder.addCase(fetchEditingChannel.rejected, (state, { payload }) => {
    state.apiError = payload
    state.isLoading = false
  })
}

export default fetchEditingChannel
